export default "__VITE_ASSET__DiHucUNL__"